export const paymentFormFields = {
    paymentDocumentForm:

        [
            {
                order: 0,
                rowClass: "row",
                name: "row-0",
                fields: [
                    {
                        order: 0,
                        name: "documentNumber", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Numer dokumentu",
                        required: true,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz numer dokumentu",
                        helpText:
                            "Uzupełnij numer dokumentu. Pole musi zawierać od 3 do 100 znaków",
                        colClass: "col",
                    },
                ],
            },
            {
                order: 0,
                rowClass: "row",
                name: "row-1",
                fields: [
                    {
                        order: 0,
                        name: "documentType", // name is also a key in JSON
                        value: "[PP] Polecenie przelewu",
                        type: "select", // available types: text, number, date, checkbox, select, list and button
                        label: "Typ dokumentu",
                        required: true,
                        options: ["[PP] Polecenie przelewu"], // for select type
                        placeholder: "Wybierz typ dokumentu",
                        helpText: "Wybierz z listy możliwych typów",
                        colClass: "col col-lg-6",
                    },
                    {
                        order: 0,
                        name: "documentIssueDateTime", // name is also a key in JSON
                        value: null,
                        type: "date", // available types: text, number, date, checkbox, select, list and button
                        label: "Data wystawienia",
                        required: true,
                        options: [], // for select type
                        placeholder: "Wybierz datę wystawienia",
                        helpText: "Wybierz datę wystawienia dokumentu",
                        colClass: "col col-lg-6",
                    },
                ],
            },

            {
                order: 0,
                rowClass: "row",
                name: "row-2",
                fields: [
                    {
                        order: 0,
                        name: "payer-data-section", // name is also a key in JSON
                        value:null,
                        type: "section", // available types: text, number, date, checkbox, select, list and button
                        label: "Płatnik",
                        required: false,
                        pattern: "",
                        placeholder: "",
                        helpText: "",
                        colClass: "col",
                    },
                ],

            },

            {
                order: 0,
                rowClass: "row",
                name: "row-8",
                fields: [
                    {
                        order: 0,
                        name: "payerName", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Nazwa płatnika",
                        required: true,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz nazwę płatnika",
                        helpText: "Wpisz nazwę płatnika. Pole musi zawierać od 3 do 100 znaków",
                        colClass: "col col-lg-9",
                    },
                    {
                        order: 0,
                        name: "payerNip", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "NIP",
                        required: false,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz NIP płatnika",
                        helpText: "Wpisz NIP płatnika",
                        colClass: "col col-lg-3",
                    },
                ],
            },
            {
                order: 0,
                rowClass: "row",
                name: "row-10",
                fields: [
                    {
                        order: 0,
                        name: "payerAddress", // name is also a key in JSON
                        value: null,
                        type: "textarea", // available types: text, number, date, checkbox, select, list and button
                        label: "Adres płatnika",
                        required: false,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz adres płatnika",
                        helpText: "Wpisz adres płatnika.",
                        colClass: "col",
                    },
                ],
            },

            {
                order: 0,
                rowClass: "row",
                name: "row-9",
                fields: [
                    {
                        order: 0,
                        name: "payerAccountNumber", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Numer konta płatnika",
                        required: true,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "^[0-9 ]+$",
                        placeholder: "Wpisz numer konta płatnika",
                        helpText: "Wpisz numer konta płatnika. Pole może zawierać tylko liczby",
                        colClass: "col col-lg-9",
                    },
                    {
                        order: 0,
                        name: "payerBankName", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Bank",
                        required: false,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Bank płatnika",
                        helpText: "Wpisz nazwę banku płatnika",
                        colClass: "col col-lg-3",
                    },
                ],
            },

            {
                order: 0,
                rowClass: "row",
                name: "row-2",
                fields: [
                    {
                        order: 0,
                        name: "receiver-data-section", // name is also a key in JSON
                        value:null,
                        type: "section", // available types: text, number, date, checkbox, select, list and button
                        label: "Odbiorca",
                        required: false,
                        pattern: "",
                        placeholder: "",
                        helpText: "",
                        colClass: "col",
                    },
                ],

            },

            {
                order: 0,
                rowClass: "row",
                name: "row-3",
                fields: [
                    {
                        order: 0,
                        name: "receiverName", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Nazwa odbiorcy",
                        required: true,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz nazwę odbiorcy",
                        helpText: "Wpisz nazwę odbiorcy. Pole musi zawierać od 3 do 100 znaków",
                        colClass: "col col-lg-9",
                    },

                    {
                        order: 0,
                        name: "receiverNip", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "NIP",
                        required: false,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz NIP odbiorcy",
                        helpText: "Wpisz NIP odbiorcy.",
                        colClass: "col col-lg-3",
                    },
                ],
            },

            {
                order: 0,
                rowClass: "row",
                name: "row-5",
                fields:[
                    {
                        order: 0,
                        name: "receiverAddress", // name is also a key in JSON
                        value: null,
                        type: "textarea", // available types: text, number, date, checkbox, select, list and button
                        label: "Adres odbiorcy",
                        required: false,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        // dots and all special chars aalowed:
                        pattern: "",
                        placeholder: "Wpisz adres odbiorcy",
                        helpText: "Wpisz adres odbiorcy.",
                        colClass: "col",
                    },
                ]

            },

            {
                order: 0,
                rowClass: "row",
                name: "row-4",
                fields: [
                    {
                        order: 0,
                        name: "receiverAccountNumber", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Numer konta odbiorcy",
                        required: true,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "^[0-9 ]+$",
                        placeholder: "Wpisz numer konta odbiorcy",
                        helpText: "Wpisz numer konta odbiorcy. Pole może zawierać tylko liczby.",
                        colClass: "col col-lg-9",
                    },
                    {
                        order: 0,
                        name: "receiverBankName", // name is also a key in JSON
                        value: null,
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Bank",
                        required: false,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 100, // used only to validate text fields
                        pattern: "",
                        placeholder: "Bank odbiorcy",
                        helpText: "Wpisz nazwę banku odbiorcy.",
                        colClass: "col col-lg-3",
                    },
                ],
            },

            {
                order: 0,
                rowClass: "row",
                name: "row-2",
                fields: [
                    {
                        order: 0,
                        name: "value-data-section", // name is also a key in JSON
                        value:null,
                        type: "section", // available types: text, number, date, checkbox, select, list and button
                        label: "Dane przelewu",
                        required: false,
                        pattern: "",
                        placeholder: "",
                        helpText: "",
                        colClass: "col",
                    },
                ],

            },


            {
                order: 10,
                rowClass: "row",
                name: "row-2",
                fields: [
                    {
                        order: 0,
                        name: "documentValue", // name is also a key in JSON
                        value: null,
                        type: "number", // available types: text, number, date, checkbox, select, list and button
                        label: "Wartość dokumentu",
                        required: true,
                        options: [], // for select type
                        placeholder: "Wpisz wartość dokumentu",
                        helpText: "Wpisz wartość dokumentu",
                        colClass: "col col-lg-6",
                    },
                    {
                        order: 0,
                        name: "documentCurrency", // name is also a key in JSON
                        value: "PLN",
                        type: "text", // available types: text, number, date, checkbox, select, list and button
                        label: "Waluta",
                        required: false,
                        options: [], // for select type
                        placeholder: "Wpisz walutę",
                        helpText: "Wpisz walutę",
                        colClass: "col col-lg-6",
                    },
                ],
            },
            {
                order: 11,
                rowClass: "row",
                name: "row-12",
                fields: [
                    {
                        order: 0,
                        name: "paymentTitle", // name is also a key in JSON
                        value: null,
                        type: "textarea", // available types: text, number, date, checkbox, select, list and button
                        label: "Tytuł płatności",
                        required: true,
                        options: [], // for select type
                        minLength: 3, // used only to validate text fields
                        maxLength: 1024, // used only to validate text fields
                        pattern: "",
                        placeholder: "Wpisz tytuł płatności",
                        helpText: "Wpisz tytuł płatności. Pole musi zawierać od 3 do 100 znaków",
                        colClass: "col",
                    },
                ],
            },
        ]
};
